import React from 'react'
import {connect} from 'react-redux'
import {formValueSelector, reduxForm} from 'redux-form';
import qs from 'qs'
import Titulo from '../comum/Titulo';
import cadastrarMapaVeiculo from '../../actions/mapa-veiculo/cadastrarMapaVeiculo';
import MontadorMapaVeiculo from './MontadorMapaVeiculo';
import {showErrorMsg, showSuccessMsg} from '../../util/messagesUtil';

const selector = formValueSelector('formCadastroMapaVeiculo');


export class PainelCadastroMapaVeiculo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fileirasPrimeiroAndar: [],
            fileirasSegundoAndar: [],
            bloquearEdicaoPrimeiroAndar: false,
            bloquearEdicaoSegundoAndar: false,
            modeloVeiculo: '',
            seUmAndar: false,
            seDoisAndares: false,
            seEmbarcacao: false
        };
    }

    UNSAFE_componentWillMount() {
        const parametros = qs.parse(this.props.history.location.search, { ignoreQueryPrefix: true });

        this.setState({
            modeloVeiculo: parametros.modeloVeiculo,
            seDoisAndares: parametros.seDoisAndares === 'true',
            seUmAndar: parametros.seUmAndar === 'true',
            seEmbarcacao: parametros.seEmbarcacao === 'true'
        });
    }

    adicionarFileirasPrimeiroAndar(fileirasPrimeiroAndar) {
        this.setState({
            fileirasPrimeiroAndar,
            bloquearEdicaoPrimeiroAndar: !this.state.bloquearEdicaoPrimeiroAndar
        })
    }

    adicionarFileirasSegundoAndar(fileirasSegundoAndar) {
        this.setState({
            fileirasSegundoAndar,
            bloquearEdicaoSegundoAndar: !this.state.bloquearEdicaoSegundoAndar
        })
    }

    selecionarTipoVeiculo(tipoVeiculo) {
        this.setState({tipoVeiculo} )
    }

    criarMapa() {
        const { tipoVeiculo, seDoisAndares } = this.state;
        if (seDoisAndares && tipoVeiculo && tipoVeiculo.value === 'EMBARCACAO') {
            showErrorMsg('Não é permitido criar uma embarcação de dois andares.');
            return;
        }

        const parametros = {
            modelo: this.state.modeloVeiculo,
            fileirasPrimeiroAndar: this.state.fileirasPrimeiroAndar,
            fileirasSegundoAndar: this.state.fileirasSegundoAndar,
            seDoisAndares: this.state.seDoisAndares,
            tipoVeiculo: this.state.tipoVeiculo ? this.state.tipoVeiculo.value : null
        };

        this.props.cadastrarMapaVeiculo(parametros)
            .then(() => {
                showSuccessMsg('Modelo Cadastrado com Sucesso!');
                this.props.history.push('/painel-mapas-veiculos');
            });
    }

    exibirBotoes() {
        if ((this.state.bloquearEdicaoPrimeiroAndar && !this.state.seDoisAndares)
            || (this.state.bloquearEdicaoSegundoAndar && this.state.bloquearEdicaoPrimeiroAndar && this.state.seDoisAndares)) {
            return (
                <div className="d-flex flex-row-reverse mb-4 mr-4">
                    <button onClick={() => this.criarMapa()}
                            className="btn btn-laranja pull-right">
                        Criar Mapa
                    </button>
                </div>
            )
        }
    }

    render() {
        return (
            <div>
                <div className="row internas">
                    <Titulo texto="Cadastro de veículo" urlRetorno="/painel-mapas-veiculos"/>
                </div>
                <div className='card card-inicial'>
                    <div className='ml-2 mt-2'>
                        <h5>Modelo: {this.state.modeloVeiculo}</h5>
                        <h5>Dois Andares: {this.state.seDoisAndares ? 'SIM' : 'Não'}</h5>
                    </div>
                </div>
                <MontadorMapaVeiculo adicionarFileiras={this.adicionarFileirasPrimeiroAndar.bind(this)}
                                     edicaoBloqueada={this.state.bloquearEdicaoPrimeiroAndar} andar={1}
                                     selecionarTipoVeiculo={this.selecionarTipoVeiculo.bind(this)}
                                     tipoVeiculo={this.state.tipoVeiculo}/>
                {this.state.seDoisAndares ?
                    <MontadorMapaVeiculo adicionarFileiras={this.adicionarFileirasSegundoAndar.bind(this)}
                                         edicaoBloqueada={this.state.bloquearEdicaoSegundoAndar} andar={2}/> : ''}
                {this.exibirBotoes()}
            </div>
        )
    }
}

export const mapStateToProps = state => (
    {
        modeloVeiculo: selector(state, 'modeloVeiculo'),
        seDoisAndares: selector(state, 'seDoisAndares'),
    });


export default connect(mapStateToProps,
    {cadastrarMapaVeiculo})(reduxForm({
    form: 'formCadastroMapaVeiculo',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
})(PainelCadastroMapaVeiculo))
